/* eslint-disable */
import React from 'react';
import {
  FieldValues, useController, Path, PathValue,
} from 'react-hook-form';
import moment from 'moment';
import CustomTimePicker, { TimePickerProps, TimeValue } from '.';
import { CommonReactHookFormProps } from '../types';

interface RHFTimePickerProps<
  FormFields extends FieldValues,
> extends TimePickerProps, CommonReactHookFormProps<FormFields> {
  onTimeChange?: (date: TimeValue) => void;
}

function RHFTimePicker<FormFields extends FieldValues>(
  props: RHFTimePickerProps<FormFields>,
) {
  const {
    name,
    control,
    value,
    label,
    onChange,
    onTimeChange,
    ...rest
  } = props;

  const {
    field,
    fieldState: { error },
  } = useController<FormFields>({
    name,
    control,
    rules: { required: true },
    defaultValue: value as PathValue<FormFields, Path<FormFields>> | undefined,
  });

  const { onChange: onFieldChange } = field;

  const handleChange = (event: TimeValue) => {
    if (onTimeChange) {
      onTimeChange(event);
    }
    onFieldChange(moment(event).format());
  };

  return (
    <CustomTimePicker
      label={label}
      value={field.value}
      error={error}
      onChange={handleChange}
      {...rest}
    />
  );
}

RHFTimePicker.defaultProps = {
  onDateChange: () => {},
};

export default RHFTimePicker;
